// External imports
import React from "react";

// Internal imports
import { RequireAuth } from "./RequireAuth";

/*
A route as the router table declares it.
 */
interface RouteDefinition {
    path: string;
    element: React.ReactElement;
}

/*
Put every route in a table behind a live session.

Applied where the table is declared, so a route added to it later is guarded
without a second edit.

@routes: the table to guard. The catch-all is left alone: a 404 holds with or
         without a session.

@returns: the same table, each guarded route wrapped in RequireAuth.
 */
export function protectRoutes(routes: RouteDefinition[]): RouteDefinition[] {
    return routes.map((route) =>
        route.path === "*"
            ? route
            : {
                  ...route,
                  element: <RequireAuth>{route.element}</RequireAuth>,
              },
    );
}
